var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import { SAVVY_CONNECTION_ID_CACHE_KEY, useGetSavvyConnectionIdMutation, } from "../services/connect";
import AppBody from "../components/AppBody";
import Header from "../components/Header";
import Image from "../components/Image";
import { ImpressionType } from "../lib/constants";
import RouteHeaderLogo from "../components/RouteHeaderLogo";
import useAccountReferenceId from "../services/savvy/useAccountReferenceId";
import useAppSelector from "../hooks/useAppSelector";
import { useDidMount } from "rooks";
import useHandleAuthValid from "../hooks/useHandleAuthValid";
import { useLazyGetSearchResultsQuery } from "../services/savvy";
export default function ReconnectSuccess() {
    var _this = this;
    var accountInfo = useAppSelector(function (state) {
        var _a = state.auth, auto = _a.auto, home = _a.home;
        return auto.accountInfo || home.accountInfo;
    });
    var getSavvyConnectionId = useGetSavvyConnectionIdMutation({
        fixedCacheKey: SAVVY_CONNECTION_ID_CACHE_KEY,
    })[0];
    var getAccountReferenceId = useAccountReferenceId().getAccountReferenceId;
    var handleAuthValid = useHandleAuthValid();
    var getSearchResults = useLazyGetSearchResultsQuery()[0];
    useDidMount(function () {
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var savvyConnectionId, accountReferenceId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getSavvyConnectionId({
                            connectionId: accountInfo.connectionId,
                            temporaryConnectionToken: accountInfo.temporaryConnectionToken,
                        }).unwrap()];
                    case 1:
                        savvyConnectionId = _a.sent();
                        handleAuthValid({ savvyConnectionId: savvyConnectionId });
                        return [4 /*yield*/, getAccountReferenceId({
                                savvyConnectionId: savvyConnectionId,
                            }).unwrap()];
                    case 2:
                        accountReferenceId = _a.sent();
                        getSearchResults({
                            accountReferenceId: accountReferenceId,
                            isRemarketingSearch: false,
                            impressionType: ImpressionType.NoResults,
                        });
                        return [2 /*return*/];
                }
            });
        }); })();
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { disableClose: true },
            React.createElement(RouteHeaderLogo, null)),
        React.createElement(AppBody, null,
            React.createElement("div", null,
                React.createElement(Image, { src: "/assets/images/thumbs-up.svg", alt: "", className: "mx-auto" })),
            React.createElement("div", { className: "px-6 pt-4 md:pt-7" },
                React.createElement("div", { className: "mb-4 md:mb-5" },
                    React.createElement("h2", { className: "text-2xl font-bold" }, "You're all set!"),
                    React.createElement("p", { className: "text-2xl" }, "Here's what's next")),
                React.createElement("div", { className: "" },
                    React.createElement("div", { className: "flex flex-col items-center rounded-2xl border border-gray-300 p-4 md:p-6" },
                        React.createElement("div", { className: "relative pb-4 md:pb-6" },
                            React.createElement("div", { className: "absolute bottom-0 left-[13px] top-0 w-1 bg-gray-300" }),
                            React.createElement("div", { className: "relative flex flex-row gap-1" },
                                React.createElement("div", { className: "flex h-8 w-8 flex-shrink-0 items-center justify-center self-start rounded-full border border-savvy-100 bg-savvy-100" },
                                    React.createElement("p", { className: "text-white" }, "1")),
                                React.createElement("p", { className: "self-end px-2 pt-1 text-base font-bold text-savvy-100" }, "One of our licensed agents will review your policies."))),
                        React.createElement("div", { className: "flex flex-row gap-1" },
                            React.createElement("div", { className: "flex h-8 w-8 flex-shrink-0 items-center justify-center self-start rounded-full border border-gray-300 bg-gray-300" },
                                React.createElement("p", { className: "text-black" }, "2")),
                            React.createElement("p", { className: "self-end px-2 pt-1 text-base font-normal text-black-300" }, "You will get an email, text, and/or phone call when a quote is available for comparable coverage at a better rate."))))))));
}
